import { tableDefaults, renderClickableText } from "./defaultConfig.js";
import { deepLink, isResolvedName } from "../../../../app/utils/deepLink.js";

export const timeLogTableConfig = () => {
    let _dateFilterValue = null;

    return {
        ...tableDefaults,
        initialSort: [
            { column: "date", dir: "desc" },
        ],
        rowFormatter: (row) => {
            const element = row.getElement();
            const data = row.getData();
            element.classList.toggle("day-off-row", !!data.isDayOff || !!data.isWeekend);
        },
        columns: [
            {
                title: "Mitarbeiter",
                field: "memberId",
                headerFilter: "list",
                headerFilterParams: { values: [] },
                visible: false,
                formatter: (cell) => {
                    const data = cell.getRow().getData();
                    const name = data.memberName ?? "";
                    if (!name) return "";
                    return renderClickableText(name, deepLink('Users.Read', `#users/${data.memberId}`, data.memberId != null && isResolvedName(name)));
                },
            },
            {
                title: "Team",
                field: "teamId",
                headerFilter: "list",
                headerFilterParams: { values: [] },
                visible: false,
                formatter: (cell) => {
                    const data = cell.getRow().getData();
                    const name = data.teamName ?? "";
                    if (!name) return "";
                    return renderClickableText(name, deepLink('Teams.Read', `#teams?col-name=${encodeURIComponent(name)}`, data.teamId != null && isResolvedName(name)));
                },
            },
            {
                title: "Datum",
                field: "date",
                hozAlign: "center",
                headerFilter: (cell, onRendered, success) => {
                    const el = document.createElement('app-input');
                    el.setAttribute('type', 'datepicker');
                    el.setAttribute('max', new Date().toISOString().slice(0, 10));
                    el.style.cssText = 'width:100%';

                    el.addEventListener('input-change', (e) => {
                        _dateFilterValue = e.detail.value;
                        success(e.detail.value);
                    });

                    if (_dateFilterValue) {
                        const obs = new MutationObserver(() => {
                            if (!el.hasAttribute('loaded')) return;
                            obs.disconnect();
                            el.setValue(_dateFilterValue, { silent: true });
                        });
                        obs.observe(el, { attributes: true, attributeFilter: ['loaded'] });
                    }

                    return el;
                },
                headerFilterEmptyCheck: (value) => !value,
                headerFilterFunc: (headerVal, rowVal) => headerVal === rowVal,
                formatter: (cell) => {
                    const val = cell.getValue();
                    if (!val) return "";
                    const [y, m, d] = val.split("-");
                    return `${d}.${m}.${y}`;
                },
                accessorDownload: (value) => {
                    if (!value) return "";
                    const [y, m, d] = value.split("-").map(Number);
                    return new Date(y, m - 1, d);
                },
                sorter: (a, b) => new Date(a) - new Date(b),
            },
            { title: "Start",   field: "start",         headerFilter: "input", hozAlign: "center" },
            { title: "Ende",    field: "end",           headerFilter: "input", hozAlign: "center" },
            { title: "Pausen", field: "breakSegments", headerFilter: "input", widthGrow: 3 },
            { title: "Pausenzeit (h)",      field: "breakTime", headerFilter: "input", hozAlign: "center" },
            { title: "Arbeitszeit (h)",     field: "duration",  headerFilter: "input", hozAlign: "center" }
        ],
    };
};